export enum SMBG_SECTION {
  Intro_section = "Intro_section",
  Glucose_food_log = "Glucose_food_log",
  Feedback = "Feedback",
  Weekly_insight = "Weekly_insight",
  Trends = "Trends",
  Logbook = "Logbook",
  Learn = "Learn",
  Start_logging_now = "Start_logging_now",
  Success_stories = "Success_stories",
  For_you = "For_you",
}

export enum SMBG_SECTION_POSITION {
  Intro_section = 1,
  Glucose_food_log = 2,
  Feedback = 3,
  Weekly_insight = 4,
  Trends = 5,
  Logbook = 6,
  Learn = 7,
  Start_logging_now = 8,
  Success_stories = 9,
  For_you = 10,
}
